import { render, staticRenderFns } from "./TradEditor.vue?vue&type=template&id=26b3c6f6"
import script from "./TradEditor.vue?vue&type=script&lang=js"
export * from "./TradEditor.vue?vue&type=script&lang=js"
import style0 from "./TradEditor.vue?vue&type=style&index=0&id=26b3c6f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports